import { useLocation, useNavigate } from 'react-router-dom'
import { useLocationContext } from '@/components/layout/LocationLayout'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import {
  LocationGeneralTab,
  LocationUsersTab,
} from '@/components/settings/location-settings'
import { LocationPricingTab } from '@/components/settings/location-pricing/LocationPricingTab'
import { LocationCatalogTab } from '@/components/settings/location-pricing/LocationCatalogTab'
import { LocationIntegrationsTab } from '@/components/settings/location-integrations/LocationIntegrationsTab'
import { LocationImportTab } from '@/components/hangarmax-import'

const VALID_TABS = ['general', 'users', 'pricing', 'services', 'integrations', 'import'] as const
type SettingsTab = (typeof VALID_TABS)[number]

export function LocationSettingsPage() {
  const { locationSlug, locationName } = useLocationContext()
  const location = useLocation()
  const navigate = useNavigate()

  // Extract active tab from URL: /{slug}/settings/{tab}
  const pathSegments = location.pathname.split('/')
  const lastSegment = pathSegments[pathSegments.length - 1] as SettingsTab
  const activeTab = VALID_TABS.includes(lastSegment) ? lastSegment : 'general'

  const handleTabChange = (tab: string) => {
    navigate(`/${locationSlug}/settings/${tab}`, { replace: true })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Location Settings</h1>
        <p className="text-muted-foreground mt-1">
          Manage settings for {locationName}
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="users">Users & Access</TabsTrigger>
          <TabsTrigger value="pricing">Pricing</TabsTrigger>
          <TabsTrigger value="services">Services</TabsTrigger>
          <TabsTrigger value="integrations">Integrations</TabsTrigger>
          <TabsTrigger value="import">Import</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="mt-6">
          <LocationGeneralTab />
        </TabsContent>
        <TabsContent value="users" className="mt-6">
          <LocationUsersTab />
        </TabsContent>
        <TabsContent value="pricing" className="mt-6">
          <LocationPricingTab />
        </TabsContent>
        <TabsContent value="services" className="mt-6">
          <LocationCatalogTab />
        </TabsContent>
        <TabsContent value="integrations" className="mt-6">
          <LocationIntegrationsTab />
        </TabsContent>
        <TabsContent value="import" className="mt-6">
          <LocationImportTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
